import AssignSubProductCategoryToQuestionnaireModal from "./AssignSubProductCategoryToQuestionnaireModal";

export default AssignSubProductCategoryToQuestionnaireModal;
